// src/components/PrivateRoute.tsx
import { InteractionRequiredAuthError, SilentRequest } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { JSX, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router';

interface PrivateRouteParams {
    children: JSX.Element;
}

const loginRequest: SilentRequest = {
    scopes: ['user.read'], // adjust as needed
};

const PrivateRoute = ({
    children
}: PrivateRouteParams) => {
    const { instance, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const location = useLocation();

    useEffect(() => {
        const acquireToken = () => {
            if (accounts.length) {
                instance.acquireTokenSilent({
                    ...loginRequest,
                    account: accounts[0],
                    forceRefresh: true,
                }).then().catch((e) => {
                    console.error(e);
                    if (e instanceof InteractionRequiredAuthError) instance.loginPopup(loginRequest).then().catch((e) => { console.error(e); });
                });
            };
        }

        const interval = setInterval(() => { acquireToken(); }, (1000 * 60 * 5));
        acquireToken();

        return () => {
            clearInterval(interval);
        }
    }, [isAuthenticated, instance]);

    if (!isAuthenticated) {
        return <Navigate to="/signin" state={{ from: location }} replace />;
    }

    const user = accounts[0];

    if (!user) return <Navigate to="/" />;

    const isInternal = user.tenantId === "05cdf50c-1c89-4622-811d-8885a6d883d4";

    if (!isInternal) return <Navigate to="/" />;

    return children;

};

export default PrivateRoute;
